/// <reference path="../../screens/panelseleccion/components/cuenta/canalventa.jsx" />
'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../Common/Helpers/GlobalHelper';

/**
 * Importación de las Actions.
 */
import {
    INITIAL_STATE_PANEL_SELECCION,
    GET_PANEL_SELECCION_DATA,
    GET_CUENTA_DATA_PANEL,
    GET_EMPRESA_DATA_PANEL,
    GET_TARJETAS_DATA_PANEL,
    CHANGE_INPUT_PANEL,
    FILTRO_RUBROS_EMPRESA_PANEL,
    CHANGE_RUBRO_EMPRESA_PANEL,
    SELECT_COMBO_PANEL,
    SELECT_RUBRO_EMPRESA_PANEL,
    CHANGE_DATES_EMPRESA_PANEL,
    CHANGE_DATES_CUENTA_PANEL,
    CHANGE_DATES_TARJETA_PANEL,
    GET_DOMICILIOS_PANEL,
    MOSTRAR_COMPONENTE_PANEL,
    CHANGE_CHECK_PANEL,
    SAVE_NOVEDAD_PANEL,
    CANCEL_NOVEDAD_PANEL,
    ESTADO_EDICION_PANEL,
    GUARDAR_CAMPO_PANEL,
    CHANGE_DATE_PANEL,
    CHANGE_DATE_ERROR_PANEL,
    GET_CUENTAS_SUCURSALES_PANEL,
    ESTA_GUARDANDO_PANEL,
    CHANGE_TEXT,
    CHANGE_EDIT_VIEW,
    BLOQUEAR_TARJETA,
    MOSTRAR_MODAL,
    ACTUALIZAR_ESTADO_NOVEDAD,
    GET_NOVEDADES_BY_ID_AND_CODIGO,
    MOSTRAR_SPINNER,
    OCULTAR_SPINNER_PANEL_SELECCION,
    MOSTRAR_SALDOS_RESUMENES,
    MOSTRAR_INGRESO_AJUSTES,
    MOSTRAR_INGRESO_COBRANZAS,
    GET_DIAS_VIGENCIA_PANEL,
    CHANGE_ENTIDAD_TARJETA_PANEL,
    MOSTRAR_MODAL_BAJA_CUENTA,
    OCULTAR_MODAL_BAJA_CUENTA,
    VALOR_TEXT_AREA,
    VALOR_SELECT,
    CHECK_SOLICITAR_CAIDA_CUOTAS,
    NUMERO_BAJA_CUENTA
} from '../../Screens/PanelSeleccion/actions/PanelSeleccionActions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        loading: false,
        entidadTipo: undefined,
        empresaDatos: undefined,
        empresaDatosOriginal: undefined,
        novedadesEmpresaDatos: undefined,
        novedadesCuentaDatos: undefined,
        novedadesTarjetaDatos: undefined,
        domiciliosService: undefined,
        cuentaDatos: undefined,
        cuentaDatosOriginal: undefined,
        mostrarDebitoCuenta: false,
        componenteSeleccionado: undefined,
        valorAnterior: undefined,
        seEstaEditando: false,
        descripcionEmpresa: undefined,
        valueBuscador: "",
        atlasBonificacionRenovacion: undefined,
        atlasCartera: undefined,
        cobraValorRenovacion: undefined,
        novedadEmpresaValorAlRenovar: undefined,
        valorSelectIdSeleccionado: undefined,
        valorDataPickerSeleccionado: undefined,
        seEstaEditandoValorRenovacion: undefined,
        entidadInstaciasEquivalenciaCodigoIva: undefined,
        sucursalesCuentas: undefined,
        dataPickerError: undefined,
        mostrarCodigoGeografico: undefined,
        CodGeoPartSeleccionado: undefined,
        cuentaDenominacion: undefined,
        sucursal: undefined,
        modeloLiquidacion: undefined,
        grupoAfinidad: undefined,
        limiteCompra: undefined,
        agrupamiento: undefined,
        formaPago: undefined,
        promotor: undefined,
        lineaPrestamo: undefined,
        categoriaCajero: undefined,
        formaDebito: undefined,
        cuentaBancariaSucursalId: undefined,
        CuentaBancariaSucursalCodigo: undefined,
        cuentaBancariaNumero: undefined,
        domicilioSeleccionadoArray: [],
        mensajeActivo: undefined,
        seVisualizaEditado: undefined,
        CuentaBancariaSucursalSelected: undefined,
        tarjetas: undefined,
        vigenciaTarjeta: undefined,
        minimoValorLimite: undefined,
        tarjetasDatosOriginal: undefined,
        esTarjetaBloqueada: false,
        motivosBloqueo: undefined,
        novedadesTarjetaDatosCanceladas: undefined,
        tipoTarjetas: undefined,
        funcionesDelUsuario: undefined,
        estaVisibleModalNovedad: false,
        novedadesHistoria: undefined,
        SaldosResumenesLimitesActivado: true,
        tituloCampo: "",
        estaVisibleModalBajaCuenta: false,
        valorTxtArea: "",
        motivoBajaId: 0,
        bajaId: 0,
        checkSolcitarCaidaCuotas: false,
        mostrarIngresoAjustes: false,
        mostrarIngresoCobranzas: false,
        esNovedadEditada: [
            //Empresa
            { 'campoCodigo': 'DESCR_EMPR', 'editado': false }, //Descripcion Empresa
            { 'campoCodigo': 'DENOM_EMPR', 'editado': false }, //Denominación Empresa
            { 'campoCodigo': 'ESCON_EMPR', 'editado': false }, //Es Confidencial
            { 'campoCodigo': 'DOMIC_EMPR', 'editado': false }, //Domicilio
            { 'campoCodigo': 'DESTI_EMPR', 'editado': false }, //Destinatario Reportes
            { 'campoCodigo': 'NUECL_EMPR', 'editado': false }, //Home Banking (nueva clave)
            { 'campoCodigo': 'CARTE_EMPR', 'editado': false }, //Cartera
            { 'campoCodigo': 'RUBRO_EMPR', 'editado': false }, //Rubros
            { 'campoCodigo': 'PERAD_EMPR', 'editado': false }, //Permite Adelantos
            { 'campoCodigo': 'LIMTR_EMPR', 'editado': false }, //Limite Transaccion
            { 'campoCodigo': 'CONEX_EMPR', 'editado': false }, //Consumo Exterior
            { 'campoCodigo': 'REPCU_EMPR', 'editado': false }, //Reporte Cuenta Central
            { 'campoCodigo': 'MODLI_EMPR', 'editado': false }, //Modelo de Liquidacion
            { 'campoCodigo': 'BONRE_EMPR', 'editado': false }, //Bonificacion Renovacion
            { 'campoCodigo': 'ACTRE_EMPR', 'editado': false }, //Actualizar Valor al Renovar
            { 'campoCodigo': 'VIGPL_EMPR', 'editado': false }, //Vigencia Plasticos
            { 'campoCodigo': 'FETOP_EMPR', 'editado': false }, //Fecha Tope Agro
            { 'campoCodigo': 'VIG_A_EMPR', 'editado': false }, //Vigencia alta
            { 'campoCodigo': 'VIG_R_EMPR', 'editado': false }, //Vigencia Renovacion
            //Cuenta
            { 'campoCodigo': 'AGRUP_CUEN', 'editado': false }, //Agrupamiento
            { 'campoCodigo': 'CANVT_CUEN', 'editado': false }, //Canal de Venta
            { 'campoCodigo': 'CATAT_CUEN', 'editado': false }, //Categorias ATM
            { 'campoCodigo': 'CODPL_CUEN', 'editado': false }, //Codigo Planta
            { 'campoCodigo': 'FRMDB_CUEN', 'editado': false }, //Forma Pago Debito Cuenta
            { 'campoCodigo': 'FRMPG_CUEN', 'editado': false }, //Forma Pago
            { 'campoCodigo': 'SUCUR_CUEN', 'editado': false }, //Sucursales
            { 'campoCodigo': 'DENOM_CUEN', 'editado': false }, //Denominación Cuenta
            { 'campoCodigo': 'DESCR_CUEN', 'editado': false }, //Descripcion Cuenta
            { 'campoCodigo': 'DOMCO_CUEN', 'editado': false }, //Domicilio Correspondencia
            { 'campoCodigo': 'FLCC_CUEN', 'editado': false }, //FLCC
            { 'campoCodigo': 'SUCUE_CUEN', 'editado': false }, //Forma Pago Sucursal
            { 'campoCodigo': 'CUEBC_CUEN', 'editado': false }, //Forma Pago Cuenta Bancaria
            { 'campoCodigo': 'GRUPA_CUEN', 'editado': false }, //Grupo Afinidad
            { 'campoCodigo': 'LIMFI_CUEN', 'editado': false }, //Limite Financiacion
            { 'campoCodigo': 'LINPR_CUEN', 'editado': false }, //Lineas Prestamo
            { 'campoCodigo': 'MODLI_CUEN', 'editado': false }, //Modelos Liquidacion
            { 'campoCodigo': 'PROMO_CUEN', 'editado': false }, //Promotor
            { 'campoCodigo': 'DOMPA_CUEN', 'editado': false }, //Domicilio Particular Codigo Geografico
            { 'campoCodigo': 'LIDFT_CUEN', 'editado': false }, //Limite Defecto Tarjeta
            //Tarjeta                                          
            { 'campoCodigo': 'DENOM_TARJ', 'editado': false }, //Denominacion Tarjeta
            { 'campoCodigo': 'ESTEM_TARJ', 'editado': false }, //Es Temporal
            { 'campoCodigo': 'TITAR_TARJ', 'editado': false }, //Tipo Tarjeta
            { 'campoCodigo': 'BLOQU_TARJ', 'editado': false }, //Bloqueo
            { 'campoCodigo': 'CRLIN_TARJ', 'editado': false }, //Cuarta Linea
            { 'campoCodigo': 'VIGER_TARJ', 'editado': false }, //Vigencia Dias
            { 'campoCodigo': 'BAJA_TARJ', 'editado': false },  //Baja
            { 'campoCodigo': 'RECUP_TARJ', 'editado': false }  //Recuperada
        ]
    }
};

let result;

function panelSeleccion(state = initialState, action) {
    LogHelper.In(panelSeleccion.name, state, action);

    switch (action.type) {

        case INITIAL_STATE_PANEL_SELECCION:

            state = initialState;
            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case NUMERO_BAJA_CUENTA:

            result = {
                ...state,
                data: {
                    ...state.data,
                    bajaId: action.bajaId
                }
            }
            break;

        case GET_PANEL_SELECCION_DATA:

            let vistaCliente = action.vistaCliente.data;
            let empresa, empresaDatos, empresaDatosOriginal, descripcionEmpresa, novedadesEmpresaDatos,
                rubros, novedadEmpresaValorAlRenovar, atlasBonificacionRenovacion, atlasCartera, cobraValorRenovacion,
                cuentaDatos, novedadesCuentaDatos, cuentaDatosOriginal, porcentajeCodigoBonificacion, porcentajeCodigoBonificacionOriginal,
                cartera, carteraOriginal, entidadInstaciasEquivalenciaCodigoIva, categoriaIva, cuentaDenominacion, cuentaDescripcion, getCodigoGeograficoVisa,
                sucursal, modeloLiquidacion, grupoAfinidad, limiteCompra, formaPago, promotor, lineaPrestamo, categoriaCajero,
                agrupamiento, formaDebito, cuentaBancariaNumero, sucursalesCuentas, domiciliosService, sucursalOriginal, modeloLiquidacionOriginal,
                grupoAfinidadOriginal, limiteCompraOriginal, agrupamientoOriginal, formaPagoOriginal, promotorOriginal, lineaPrestamoOriginal,
                categoriaCajeroOriginal, formaDebitoOriginal, cuentaBancariaNumeroOriginal, cuentaBancariaSucursalId, CuentaBancariaSucursalCodigo, cuentaBuscada, tarjetasDatos,
                novedadesTarjetaDatos, tarjetasDatosOriginal, vigenciaTarjeta, minimoValorLimite, motivosBloqueo, novedadesTarjetaDatosCanceladas,
                tipoTarjetas, motivosBaja = undefined;

            let mensajeActivo, seVisualizaEditado = false;

            switch (vistaCliente.entidadTipo) {
                case 0:
                    empresa = vistaCliente.enterprises.find(x => x.Id == vistaCliente.idEntidad);
                    empresaDatos = action.empresa;
                    atlasBonificacionRenovacion = action.atlasBonificacionRenovacion;
                    atlasCartera = action.atlasCartera;
                    getCodigoGeograficoVisa = action.getCodigoGeograficoVisa;
                    entidadInstaciasEquivalenciaCodigoIva = action.entidadInstaciasEquivalenciaCodigoIva;
                    empresaDatosOriginal = JSON.parse(JSON.stringify(empresaDatos));
                    novedadesEmpresaDatos = action.novedades;
                    descripcionEmpresa = JSON.parse(JSON.stringify(empresaDatos)).Descripcion;
                    empresaDatosOriginal.rubros = JSON.parse(JSON.stringify(action.rubros));
                    empresaDatos.rubros = action.rubros;
                    domiciliosService = action.domiciliosService;

                    let buscarNovedadEmpresa = novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == "ACTRE_EMPR");
                    novedadEmpresaValorAlRenovar = buscarNovedadEmpresa != undefined ? buscarNovedadEmpresa : null
                    cobraValorRenovacion = (novedadEmpresaValorAlRenovar != undefined ? (novedadEmpresaValorAlRenovar.ValorNovedad == "0" ? false : true) : (null))

                    if (action.empresa.PorcentajeBonificacionRenovacion != undefined) {
                        let porcentajeCodigoBonificacionObj = action.atlasBonificacionRenovacion.find(x => x.ID == action.empresa.PorcentajeBonificacionRenovacion);
                        porcentajeCodigoBonificacion = {
                            'Id': porcentajeCodigoBonificacionObj.ID,
                            'Valor': porcentajeCodigoBonificacionObj.PORCENTAJEBONIFICACION
                        }
                        porcentajeCodigoBonificacionOriginal = JSON.parse(JSON.stringify(porcentajeCodigoBonificacion));
                    }

                    if (action.empresa.CarteraId != undefined) {
                        let carteraObj = action.atlasCartera.find(x => x.Id == action.empresa.CarteraId);
                        cartera = {
                            'Id': carteraObj.Id,
                            'Valor': carteraObj.Descripcion
                        }
                        carteraOriginal = JSON.parse(JSON.stringify(cartera));
                    }

                    if (action.empresa.CategoriaIvaId != undefined) {
                        categoriaIva = action.entidadInstaciasEquivalenciaCodigoIva.Descripcion;//action.entidadInstaciasEquivalenciaCodigoIva.DESCRIPCION;
                    }
                    /*Se tuvo que hacer este "hack" para que las novedades de domicilio finalmente puedan funcionar*/
                    const novedadDMCGE = novedadesEmpresaDatos.find((ned) => ned.NovedadCampoCodigo == "DMCGE_EMPR");
                    const codGeograficoVisa = getCodigoGeograficoVisa.find((cgv) => {
                        if (novedadDMCGE) {
                            return (cgv.CodigoGeografico == novedadDMCGE.ValorNovedad);
                        } else {
                            return (cgv.CodigoGeografico == empresaDatos.DomicilioCodigoGeografico);
                        }
                    });

                    if (novedadDMCGE) {
                        if (codGeograficoVisa) {
                            empresaDatos.DomicilioCodigoGeografico = novedadDMCGE.ValorNovedad;
                            empresaDatos.DomicilioCodigoGeograficoInput = "";
                        } else {
                            empresaDatos.DomicilioCodigoGeografico = "0";
                            empresaDatos.DomicilioCodigoGeograficoInput = novedadDMCGE.ValorNovedad;
                        }
                    } else {
                        if (codGeograficoVisa == undefined) {
                            empresaDatos.DomicilioCodigoGeograficoInput = empresaDatos.DomicilioCodigoGeografico;
                            empresaDatos.DomicilioCodigoGeografico = "0";
                        }
                    }
                    /*fin*/
                    break;
                case 1:
                    sucursalesCuentas = action.cuenta.accountData.sucursalesCuentas;
                    domiciliosService = action.cuenta.accountData.domiciliosService;

                    vistaCliente.enterprises.map(function (empresaBuscada) {
                        cuentaBuscada = empresaBuscada.accounts.find(x => x.Id == vistaCliente.idEntidad);
                        if (cuentaBuscada != undefined) {
                            empresa = empresaBuscada;
                            return;
                        }
                    })

                    cuentaDatos = JSON.parse(JSON.stringify(action.cuenta));
                    novedadesCuentaDatos = action.novedades;
                    let cuentaDatosParse = JSON.parse(JSON.stringify(cuentaDatos));
                    cuentaDatosOriginal = cuentaDatosParse;
                    cuentaDenominacion = cuentaDatosParse.CuentaDenominacion;
                    cuentaDescripcion = cuentaDatosParse.Descripcion;

                    if (action.cuenta.SucursalId != undefined) {
                        let buscarSucursalObj = action.cuenta.accountData.GET_SUCURSAL.find(x => x.Id == action.cuenta.SucursalId);
                        sucursal = {
                            'Id': buscarSucursalObj.Id,
                            'Valor': buscarSucursalObj.Descripcion
                        }
                        sucursalOriginal = JSON.parse(JSON.stringify(sucursal));
                    }

                    if (action.cuenta.ModeloLiquidacionId != undefined) {
                        let buscarModeloLiquidacionObj = action.cuenta.accountData.GET_MODELO_LIQUIDACION.find(x => x.Id == action.cuenta.ModeloLiquidacionId);
                        modeloLiquidacion = {
                            'Id': buscarModeloLiquidacionObj.Id,
                            'Valor': buscarModeloLiquidacionObj.Descripcion
                        }
                        modeloLiquidacionOriginal = JSON.parse(JSON.stringify(modeloLiquidacion));
                    }

                    if (action.cuenta.GrupoAfinidadId != undefined) {
                        let buscarGrupoAfinidad = action.cuenta.accountData.GET_GRUPO_AFINIDAD.find(x => x.Id == action.cuenta.GrupoAfinidadId);
                        grupoAfinidad = {
                            'Id': buscarGrupoAfinidad.Id,
                            'Valor': buscarGrupoAfinidad.Descripcion
                        }
                        grupoAfinidadOriginal = JSON.parse(JSON.stringify(grupoAfinidad));
                    }

                    if (action.cuenta.LimiteCompraId != undefined) {
                        let buscarLimiteCompra = action.cuenta.accountData.GET_LIMITE_COMPRA.find(x => x.Id == action.cuenta.LimiteCompraId);
                        if (buscarLimiteCompra) {
                            limiteCompra = {
                                'Id': buscarLimiteCompra.Id,
                                'Valor': buscarLimiteCompra.Valor
                            }
                        }
                        else {
                            limiteCompra = {
                                'Id': 0,
                                'Valor': 0
                            }
                        }
                        limiteCompraOriginal = JSON.parse(JSON.stringify(limiteCompra));

                    }

                    if (action.cuenta.AgrupamientoVisaId != undefined) {
                        let buscarAgrupamiento = action.cuenta.accountData.GET_AGRUPAMIENTO.find(x => x.Id == action.cuenta.AgrupamientoVisaId);
                        agrupamiento = {
                            'Id': buscarAgrupamiento.Id,
                            'Valor': buscarAgrupamiento.Descripcion
                        }
                        agrupamientoOriginal = JSON.parse(JSON.stringify(agrupamiento));
                    }

                    if (action.cuenta.FormaPagoId != undefined) {
                        let buscarFormaPago = action.cuenta.accountData.GET_FORMA_PAGO.find(x => x.Id == action.cuenta.FormaPagoId);
                        formaPago = {
                            'Id': buscarFormaPago.Id,
                            'Valor': buscarFormaPago.Descripcion
                        }
                        formaPagoOriginal = JSON.parse(JSON.stringify(formaPago));
                    }

                    if (action.cuenta.PromotorId != undefined) {
                        let buscarPromotor = action.cuenta.accountData.GET_PROMOTOR.find(x => x.Id == action.cuenta.PromotorId);
                        promotor = {
                            'Id': buscarPromotor.Id,
                            'Valor': buscarPromotor.Descripcion
                        }
                        promotorOriginal = JSON.parse(JSON.stringify(promotor));
                    }

                    if (action.cuenta.LineaPrestamoVisaId != undefined) {
                        let buscarLineaPrestamo = action.cuenta.accountData.GET_LINEA_PRESTAMO.find(x => x.Id == action.cuenta.LineaPrestamoVisaId);
                        lineaPrestamo = {
                            'Id': buscarLineaPrestamo.Id,
                            'Valor': buscarLineaPrestamo.Descripcion
                        }
                        lineaPrestamoOriginal = JSON.parse(JSON.stringify(lineaPrestamo));
                    }

                    if (action.cuenta.CategoriaCajeroVisaId != undefined) {
                        let buscarCategoriaCajero = action.cuenta.accountData.GET_CATEGORIA_CAJERO.find(x => x.Id == action.cuenta.CategoriaCajeroVisaId);
                        categoriaCajero = {
                            'Id': buscarCategoriaCajero.Id,
                            'Valor': buscarCategoriaCajero.Descripcion
                        }
                        categoriaCajeroOriginal = JSON.parse(JSON.stringify(categoriaCajero));
                    }

                    if (action.cuenta.FormaDebitoId != undefined) {
                        let buscarFormaDebito = action.cuenta.accountData.GET_FORMA_DEBITO.find(x => x.Id == action.cuenta.FormaDebitoId);
                        formaDebito = {
                            'Id': buscarFormaDebito.Id,
                            'Valor': buscarFormaDebito.Descripcion
                        }
                        formaDebitoOriginal = JSON.parse(JSON.stringify(formaDebito));
                    }

                    if (action.cuenta.CuentaBancariaNumero != undefined) {
                        let cuentas = action.cuenta.accountData.GET_CUENTAS_BANCARIAS;

                        //TODO: validar que hacer cuando llega un mensaje de error desde el wb
                        if (!(cuentas instanceof Array)) {
                            cuentas = [];
                        }

                        let buscarCuentaBancariaNumero = cuentas.find(x => x.numero == action.cuenta.CuentaBancariaNumero);

                        if (buscarCuentaBancariaNumero) {
                            cuentaBancariaNumero = {
                                'Id': buscarCuentaBancariaNumero.numero,
                                'Valor': buscarCuentaBancariaNumero.numero
                            }
                            cuentaBancariaNumeroOriginal = JSON.parse(JSON.stringify(cuentaBancariaNumero));
                        }
                    }

                    cuentaBancariaSucursalId = action.cuenta.CuentaBancariaSucursalId;
                    CuentaBancariaSucursalCodigo = action.cuenta.CuentaBancariaSucursalCodigo;
                    break;
                case 2: {
                    vistaCliente.enterprises.forEach((emp) => {
                        emp.accounts.forEach((acc) => {
                            acc.EmpresaVisaId = emp.Id;
                            if (acc.Id == vistaCliente.idEntidad) {
                                cuentaDatos = JSON.parse(JSON.stringify(acc));
                            }
                        });
                    });

                    empresa = vistaCliente.enterprises.find((emp) => emp.Id == cuentaDatos.EmpresaVisaId);

                    tipoTarjetas = action.tipoTarjetas;
                    tarjetasDatos = action.tarjetas;
                    motivosBloqueo = tarjetasDatos.motivos;
                    motivosBaja = tarjetasDatos.motivosBaja;
                    tarjetasDatosOriginal = JSON.parse(JSON.stringify(tarjetasDatos))
                    novedadesTarjetaDatos = action.novedades;
                    novedadesTarjetaDatosCanceladas = action.novedadesCanceladas;
                    vigenciaTarjeta = action.vigenciaTarjeta;
                    minimoValorLimite = action.minimoValorLimite;
                    break;
                }
            }

            state.data.esNovedadEditada.map(function (row) {
                row.editado = false
            });

            result = {
                ...state,
                data: {
                    ...state.data,
                    agrupamiento: agrupamiento,
                    agrupamientoOriginal: agrupamiento,
                    atlasBonificacionRenovacion: atlasBonificacionRenovacion,
                    atlasCartera: atlasCartera,
                    cartera: cartera,
                    carteraOriginal: carteraOriginal,
                    categoriaCajero: categoriaCajero,
                    categoriaCajeroOriginal: categoriaCajeroOriginal,
                    categoriaIva: categoriaIva,
                    cobraValorRenovacion: cobraValorRenovacion,
                    cuentaBancariaNumero: cuentaBancariaNumero,
                    cuentaBancariaNumeroOriginal: cuentaBancariaNumeroOriginal,
                    CuentaBancariaSucursalSelected: cuentaBancariaSucursalId,
                    CuentaBancariaSucursalCodigo: CuentaBancariaSucursalCodigo,
                    cuentaDatos: cuentaDatos,
                    cuentaDatosOriginal: cuentaDatosOriginal,
                    cuentaDenominacion: cuentaDenominacion,
                    cuentaDescripcion: cuentaDescripcion,
                    descripcionEmpresa: descripcionEmpresa,
                    domiciliosService: domiciliosService,
                    empresa: empresa,
                    empresaDatos: empresaDatos,
                    empresaDatosOriginal: empresaDatosOriginal,
                    entidadTipo: vistaCliente.entidadTipo,
                    formaDebito: formaDebito,
                    formaDebitoOriginal: formaDebitoOriginal,
                    formaPago: formaPago,
                    formaPagoOriginal: formaPagoOriginal,
                    funcionesDelUsuario: action.funcionesDelUsuario,
                    getCodigoGeograficoVisa: getCodigoGeograficoVisa,
                    grupoAfinidad: grupoAfinidad,
                    grupoAfinidadOriginal: grupoAfinidadOriginal,
                    lineaPrestamo: lineaPrestamo,
                    lineaPrestamoOriginal: lineaPrestamoOriginal,
                    loading: false,
                    mensajeActivo: mensajeActivo,
                    minimoValorLimite: minimoValorLimite,
                    modeloLiquidacion: modeloLiquidacion,
                    modeloLiquidacionOriginal: modeloLiquidacionOriginal,
                    motivosBaja: motivosBaja,
                    motivosBloqueo: motivosBloqueo,
                    novedadEmpresaValorAlRenovar: novedadEmpresaValorAlRenovar,
                    novedadesCuentaDatos: novedadesCuentaDatos,
                    novedadesEmpresaDatos: novedadesEmpresaDatos,
                    novedadesTarjetaDatos: novedadesTarjetaDatos,
                    novedadesTarjetaDatosCanceladas: novedadesTarjetaDatosCanceladas,
                    porcentajeCodigoBonificacion: porcentajeCodigoBonificacion,
                    porcentajeCodigoBonificacionOriginal: porcentajeCodigoBonificacionOriginal,
                    promotor: promotor,
                    promotorOriginal: promotorOriginal,
                    seVisualizaEditado: seVisualizaEditado,
                    sucursal: sucursal,
                    sucursalesCuentas: sucursalesCuentas,
                    sucursalOriginal: sucursalOriginal,
                    tarjetasDatos: tarjetasDatos,
                    tarjetasDatosOriginal: tarjetasDatosOriginal,
                    tipoTarjetas: tipoTarjetas,
                    vigenciaTarjeta: vigenciaTarjeta,
                    vistaCliente: vistaCliente,
                    bajaId: action.bajaId,
                    features: action.features
                }

            };
            break;

        case GET_CUENTA_DATA_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            }
            break;

        case GET_EMPRESA_DATA_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            }
            break;

        case GET_TARJETAS_DATA_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            }
            break;

        case MOSTRAR_MODAL_BAJA_CUENTA:

            result = {
                ...state,
                data: {
                    ...state.data,
                    estaVisibleModalBajaCuenta: true
                }
            }
            break;

        case OCULTAR_MODAL_BAJA_CUENTA:

            result = {
                ...state,
                data: {
                    ...state.data,
                    estaVisibleModalBajaCuenta: false
                }
            }
            break;

        case VALOR_SELECT:

            result = {
                ...state,
                data: {
                    ...state.data,
                    motivoBajaId: action.id
                }
            }
            break;

        case CHECK_SOLICITAR_CAIDA_CUOTAS:

            result = {
                ...state,
                data: {
                    ...state.data,
                    checkSolcitarCaidaCuotas: !state.data.checkSolcitarCaidaCuotas
                }
            }
            break;

        case CHANGE_RUBRO_EMPRESA_PANEL:

            setRubroValue(state, action.valueBuscador, action.select);
            result = {
                ...state,
                data: {
                    ...state.data,
                }
            };
            break;
        case FILTRO_RUBROS_EMPRESA_PANEL:

            limpiarRubros(state);
            filtroRubro(state, action.typeInput, action.isCheck);
            result = {
                ...state,
                data: {
                    ...state.data,
                }
            };
            break;

        case CHANGE_INPUT_PANEL:
            let valorAnterior;
            let existeNovedad;
            let index;
            switch (action.entidadId) {
                case 0:
                    switch (action.componente) {
                        case 'DENOM_EMPR': //Denominación de la empresa 
                            valorAnterior = state.data.empresaDatosOriginal.Denominacion;
                            state.data.empresaDatos.Denominacion = action.value;
                            break;
                        case 'DESTI_EMPR': //Destinatario de reportes
                            valorAnterior = state.data.empresaDatosOriginal.DestinatarioReportes;
                            state.data.empresaDatos.DestinatarioReportes = action.value;
                            break;
                        case 'VIG_A_EMPR': //Vigencia alta
                            valorAnterior = state.data.empresaDatosOriginal.VigenciaAlta;
                            state.data.empresaDatos.VigenciaAlta = action.value;
                            break;
                        case 'VIG_R_EMPR': //Vigencia renovacion
                            valorAnterior = state.data.empresaDatosOriginal.VigenciaRenovacion;
                            state.data.empresaDatos.VigenciaRenovacion = action.value;
                            break;
                    }
                    existeNovedad = state.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                case 1: {
                    switch (action.componente) {
                        case 'DENOM_CUEN':
                            valorAnterior = state.data.cuentaDatosOriginal.CuentaDenominacion;
                            state.data.cuentaDatos.CuentaDenominacion = action.value;
                            break;
                        case 'DESCR_CUEN':
                            valorAnterior = state.data.cuentaDatosOriginal.Descripcion;
                            state.data.cuentaDatos.Descripcion = action.value;
                            break;
                        case "DOMCO_CUEN": {
                            const { DomicilioCorrespondencia2 } = state.data.cuentaDatos;

                            switch (action.parametros[1]) {
                                case "DMCGE_CUEN": {
                                    /*el usuario hizo click en Otro*/
                                    if (action.value == "" || action.parametros[0] == true) {
                                        DomicilioCorrespondencia2.CodigoGeografico.EsOtro = true;
                                    } else {
                                        DomicilioCorrespondencia2.CodigoGeografico.EsOtro = false;
                                    }

                                    if (DomicilioCorrespondencia2.CodigoGeografico.Novedad) {
                                        DomicilioCorrespondencia2.CodigoGeografico.NovedadEditada = true;
                                    }

                                    DomicilioCorrespondencia2.CodigoGeografico.Valor = action.value;

                                    break;
                                }
                                case "": {
                                    break;
                                }
                            }
                            state.data.cuentaDatos.DomicilioCorrespondencia2
                            break;
                        }
                        case 'CODPL_CUEN':
                            valorAnterior = state.data.cuentaDatosOriginal.Planta;
                            state.data.cuentaDatos.Planta = action.value;
                            break;
                        case 'LIDFT_CUEN':
                            valorAnterior = (state.data.cuentaDatosOriginal.LimiteDefaultTarjetas || "");
                            state.data.cuentaDatos.LimiteDefaultTarjetas = action.value;
                            break;
                        case 'LIMFI_CUEN':
                            valorAnterior = state.data.cuentaDatosOriginal.LimiteFinanciacion;
                            state.data.cuentaDatos.LimiteFinanciacion = action.value;
                            break;
                        case 'FLCC_CUEN':
                            valorAnterior = state.data.cuentaDatosOriginal.Flcc;
                            state.data.cuentaDatos.Flcc = action.value;
                            break;
                        case 'CANVT_CUEN':
                            valorAnterior = state.data.cuentaDatosOriginal.CanalVentaVisaCodigo;
                            state.data.cuentaDatos.CanalVentaVisaCodigo = action.value;
                            break;
                        default:
                    }
                    existeNovedad = state.data.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                }
                case 2:
                    switch (action.componente) {
                        case 'DENOM_TARJ': //Denominacion de la tarjeta 
                            index = state.data.tarjetasDatosOriginal.findIndex(x => x.TarjetaCreditoId == action.id);
                            if (index != -1) {
                                valorAnterior = state.data.tarjetasDatosOriginal[index].Denominacion;
                                state.data.tarjetasDatos[index].Denominacion = action.value;
                            }
                            break;
                        case 'CRLIN_TARJ': //Cuarta linea de la tarjeta 
                            index = state.data.tarjetasDatosOriginal.findIndex(x => x.TarjetaCreditoId == action.id);
                            if (index != -1) {
                                valorAnterior = state.data.tarjetasDatosOriginal[index].CuartaLinea;
                                state.data.tarjetasDatos[index].CuartaLinea = action.value;
                            }
                            break;
                        default:
                    }
                    existeNovedad = state.data.novedadesTarjetaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
            }

            if (existeNovedad != undefined) {
                index = state.data.esNovedadEditada.findIndex(x => x.campoCodigo == action.componente);
                state.data.esNovedadEditada[index].editado = true;
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    componenteSeleccionado: action.componente,
                    valorAnterior: valorAnterior
                }
            }
            break;

        case SELECT_COMBO_PANEL: {
            const { esNovedadEditada } = state.data;

            let valorSelectIdSeleccionado2;
            let valorAnterior2;
            let valorAnterior3;

            let existeNovedad2;
            let index2;
            let cartera2 = undefined;
            let carteraOriginal2 = undefined;
            let porcentajeCodigoBonificacion2 = undefined;
            let porcentajeCodigoBonificacionOriginal2 = undefined;
            let mostrarCodigoGeografico2 = false;

            let limiteCompra2 = undefined;
            let limiteCompraOriginal2 = undefined;

            switch (action.entidadId) {
                case 0:
                    switch (action.componente) {
                        case 'DOMIC_EMPR': //Domicilio
                            let codigoDom = action.params[0];
                            let domicilio = (state.data.domiciliosService || []).find((domi) => domi.CodigoDomicilio == codigoDom);

                            if (domicilio) {
                                valorAnterior2 = {
                                    'DomicilioBancoTipo': state.data.empresaDatosOriginal.DomicilioBancoTipo,
                                    'DomicilioCodigoGeografico': state.data.empresaDatosOriginal.DomicilioCodigoGeografico,
                                    'DomicilioCalle': state.data.empresaDatosOriginal.DomicilioCalle,
                                    'DomicilioNumero': state.data.empresaDatosOriginal.DomicilioNumero,
                                    'DomicilioLod': state.data.empresaDatosOriginal.DomicilioLod,
                                    'DomicilioCodigoPostal': state.data.empresaDatosOriginal.DomicilioCodigoPostal,
                                    'Telefono': state.data.empresaDatosOriginal.Telefono,
                                    'Caracteristica': state.data.empresaDatosOriginal.Caracteristica
                                }

                                state.data.empresaDatos.DomicilioCalle = domicilio.Calle;
                                state.data.empresaDatos.DomicilioNumero = domicilio.Numero;
                                state.data.empresaDatos.DomicilioLod = domicilio.Localidad;
                                state.data.empresaDatos.DomicilioCodigoPostal = domicilio.CodigoPostal;
                                state.data.empresaDatos.Telefono = domicilio.Telefono.Numero;
                                state.data.empresaDatos.Caracteristica = domicilio.Telefono.Caracteristica;
                                state.data.empresaDatos.DomicilioBancoTipo = domicilio.CodigoDomicilio;
                            }

                            mostrarCodigoGeografico2 = true;
                            break;
                        case 'CARTE_EMPR': //Cartera
                            valorAnterior2 = state.data.empresaDatosOriginal.CarteraId;
                            state.data.empresaDatos.CarteraId = action.id;

                            let buscarCartera2 = state.data.atlasCartera.find(x => x.ID == action.id);
                            cartera2 = {
                                'Id': buscarCartera2.ID,
                                'Valor': buscarCartera2.DESCRIPCION
                            }
                            carteraOriginal2 = state.data.cartera;
                            break;
                        case 'BONRE_EMPR': //Bonificación de la renovación
                            valorAnterior2 = state.data.empresaDatosOriginal.PorcentajeBonificacionRenovacion;
                            state.data.empresaDatos.PorcentajeBonificacionRenovacion = action.id;

                            let buscarPorcentajeCodigoBonificacion2 = state.data.atlasBonificacionRenovacion.find(x => x.ID == action.id);
                            porcentajeCodigoBonificacion2 = {
                                'Id': buscarPorcentajeCodigoBonificacion2.ID,
                                'Valor': buscarPorcentajeCodigoBonificacion2.PORCENTAJEBONIFICACION
                            }
                            porcentajeCodigoBonificacionOriginal2 = state.data.porcentajeCodigoBonificacion;
                            break;
                        default:
                    }
                    existeNovedad2 = state.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                case 1:
                    const { cuentaDatos, cuentaDatosOriginal } = state.data;

                    switch (action.componente) {
                        /*Domicilio Correspondencia*/
                        case 'DOMCO_CUEN': {
                            const { domiciliosService } = state.data;
                            let { DomicilioCorrespondencia2 } = state.data.cuentaDatos;

                            if (domiciliosService) {
                                const domicilio = domiciliosService.find(ds => ds.CodigoDomicilio == action.id);

                                if (domicilio) {
                                    DomicilioCorrespondencia2.BancoTipo.Valor = domicilio.CodigoDomicilio;
                                    DomicilioCorrespondencia2.Calle.Valor = domicilio.Calle;
                                    DomicilioCorrespondencia2.Caracteristica.Valor = domicilio.Telefono.Caracteristica;
                                    DomicilioCorrespondencia2.CodigoPostal.Valor = domicilio.CodigoPostal;
                                    DomicilioCorrespondencia2.DepartamentoPartido.Valor = domicilio.Localidad;
                                    DomicilioCorrespondencia2.Numero.Valor = domicilio.Numero;
                                    DomicilioCorrespondencia2.Telefono.Valor = domicilio.Telefono.Numero;
                                }

                                break;
                            }
                        }
                        /*Sucursales*/
                        case 'SUCUR_CUEN': {
                            cuentaDatos.SucursalId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.SucursalId;
                            break;
                        }
                        /*Agrupamiento*/
                        case 'AGRUP_CUEN': {
                            cuentaDatos.AgrupamientoVisaId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.AgrupamientoVisaId;
                            break;
                        }
                        /*Categoria Cajero */
                        case 'CATAT_CUEN': {
                            cuentaDatos.CategoriaCajeroVisaId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.CategoriaCajeroVisaId;
                            break;
                        }
                        /*Forma Debito*/
                        case 'FRMDB_CUEN': {
                            cuentaDatos.FormaDebitoId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.FormaDebitoId;
                            break;
                        }
                        /*Sucursal de la Cuenta*/
                        case 'SUCUE_CUEN': {
                            cuentaDatos.CuentaBancariaSucursalId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.CuentaBancariaSucursalId;
                            break;
                        }
                        /*Cuenta Bancaria*/
                        case 'CUEBC_CUEN': {
                            cuentaDatos.CuentaBancariaNumero = action.id;
                            valorAnterior2 = cuentaDatosOriginal.CuentaBancariaNumero;
                            break;
                        }
                        /*Modelo de Liquidacion*/
                        case 'MODLI_CUEN': {
                            cuentaDatos.ModeloLiquidacionId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.ModeloLiquidacionId;
                            break;
                        }
                        /*Limite Prestamo*/
                        case 'LINPR_CUEN': {
                            cuentaDatos.LineaPrestamoVisaId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.LineaPrestamoVisaId;
                            break;
                        }
                        /*Limite de Compra*/
                        case 'LIMCO_CUEN': {
                            valorAnterior2 = state.data.cuentaDatosOriginal.LimiteCompraId;
                            state.data.cuentaDatos.LimiteCompraId = action.id;

                            let buscarLimiteCompra2 = state.data.cuentaDatos.accountData.GET_LIMITE_COMPRA.find(x => x.Id == action.id);
                            limiteCompra2 = {
                                'Id': buscarLimiteCompra2.Id,
                                'Valor': buscarLimiteCompra2.Valor
                            }
                            limiteCompraOriginal2 = state.data.limiteCompra;
                            break;
                        }
                        /*Grupo Afinidad*/
                        case 'GRUPA_CUEN': {
                            cuentaDatos.GrupoAfinidadId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.GrupoAfinidadId;
                            break;
                        }
                        /*Promotor*/
                        case 'PROMO_CUEN': {
                            cuentaDatos.PromotorId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.PromotorId;
                            break;
                        }
                        /*Forma de Pago*/
                        case 'FRMPG_CUEN': {
                            cuentaDatos.FormaPagoId = action.id;
                            valorAnterior2 = cuentaDatosOriginal.FormaPagoId;
                            break;
                        }
                        default:
                    }
                    existeNovedad2 = state.data.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                case 2:
                    switch (action.componente) {
                        case 'BLOQU_TARJ': {
                            valorAnterior2 = "";
                            break;
                        }
                        case 'BAJA_TARJ': {
                            valorAnterior2 = "";
                            break;
                        }
                        //- CREAR SP PARA MOTIVOS
                        case 'TITAR_TARJ':

                            index = state.data.tarjetasDatosOriginal.findIndex(x => x.TarjetaCreditoId == action.params[0]);
                            if (index != -1) {
                                valorAnterior2 = state.data.tarjetasDatosOriginal[index].TarjetaTipoId;
                                state.data.tarjetasDatos[index].TarjetaTipoId = action.id;
                            }
                            break;

                        case 'VIGER_TARJ':
                            index = state.data.tarjetasDatosOriginal.findIndex(x => x.TarjetaCreditoId == action.params[0]);
                            if (index != -1) {
                                valorAnterior2 = state.data.tarjetasDatosOriginal[index].Vigencia == null ? "" : state.data.tarjetasDatosOriginal[index].Vigencia;
                                state.data.tarjetasDatos[index].Vigencia = action.id;
                            }
                            break;
                        default: {
                            break;
                        }
                    }
                    existeNovedad2 = state.data.novedadesTarjetaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado)
                    break;

            }

            if (existeNovedad2 != undefined) {
                index2 = state.data.esNovedadEditada.findIndex(x => x.campoCodigo == action.componente);
                state.data.esNovedadEditada[index2].editado = true;
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    componenteSeleccionado: action.componente,
                    valorAnterior: valorAnterior2,
                    valorSelectIdSeleccionado: action.id,
                    cartera: cartera2 != undefined ? cartera2 : state.data.cartera,
                    carteraOriginal: carteraOriginal2 != undefined ? carteraOriginal2 : state.data.carteraOriginal,
                    porcentajeCodigoBonificacion: porcentajeCodigoBonificacion2 != undefined ? porcentajeCodigoBonificacion2 : state.data.porcentajeCodigoBonificacion,
                    porcentajeCodigoBonificacionOriginal: porcentajeCodigoBonificacionOriginal2 != undefined ? porcentajeCodigoBonificacionOriginal2 : state.data.porcentajeCodigoBonificacionOriginal,
                    mostrarCodigoGeografico: mostrarCodigoGeografico2,

                    limiteCompra: limiteCompra2 != undefined ? limiteCompra2 : state.data.limiteCompra,
                    limiteCompraOriginal: limiteCompraOriginal2 != undefined ? limiteCompraOriginal2 : state.data.limiteCompraOriginal,
                }
            }
            break;
        }

        case CHANGE_DATES_EMPRESA_PANEL:

            let empresa2 = action.vistaCliente.data.enterprises.find(x => x.Id == action.vistaCliente.data.idEntidad);
            let empresaDatos2 = action.empresa;
            let atlasBonificacionRenovacion2 = action.atlasBonificacionRenovacion;
            let atlasCartera2 = action.atlasCartera;
            let getCodigoGeograficoVisa2 = action.getCodigoGeograficoVisa;
            let entidadInstaciasEquivalenciaCodigoIva2 = action.entidadInstaciasEquivalenciaCodigoIva;
            let empresaDatosOriginal2 = JSON.parse(JSON.stringify(empresaDatos2));
            let novedadesEmpresaDatos2 = action.novedades;
            let descripcionEmpresa2 = JSON.parse(JSON.stringify(empresaDatos2)).Descripcion;
            empresaDatosOriginal2.rubros = JSON.parse(JSON.stringify(action.rubros));
            empresaDatos2.rubros = action.rubros;
            let buscarNovedadEmpresa2 = novedadesEmpresaDatos2.find(x => x.NovedadCampoCodigo == "ACTRE_EMPR");
            let novedadEmpresaValorAlRenovar2 = buscarNovedadEmpresa2 != undefined ? buscarNovedadEmpresa2 : null
            let cobraValorRenovacion2 = (novedadEmpresaValorAlRenovar2 != undefined ? (novedadEmpresaValorAlRenovar2.ValorNovedad == "0" ? false : true) : (null))
            let porcentajeCodigoBonificacion3 = undefined;
            let cartera3 = undefined;
            let categoriaIva2 = undefined;

            if (action.empresa.PorcentajeBonificacionRenovacion != undefined) {
                let porcentajeCodigoBonificacionObj2 = action.atlasBonificacionRenovacion.find(x => x.ID == action.empresa.PorcentajeBonificacionRenovacion);
                porcentajeCodigoBonificacion3 = {
                    'Id': porcentajeCodigoBonificacionObj2.ID,
                    'Valor': porcentajeCodigoBonificacionObj2.PORCENTAJEBONIFICACION
                }
            }

            if (action.empresa.CarteraId != undefined) {
                let carteraObj2 = action.atlasCartera.find(x => x.ID == action.empresa.CarteraId);
                cartera3 = {
                    'Id': carteraObj2.ID,
                    'Valor': carteraObj2.DESCRIPCION
                }
            }

            if (action.empresa.CategoriaIvaId != undefined) {
                categoriaIva2 = action.entidadInstaciasEquivalenciaCodigoIva.DESCRIPCION;
            }

            state.data.esNovedadEditada.map(function (row) {
                row.editado = false
            });

            result = {
                ...state,
                data: {
                    ...state.data,
                    empresaDatos: empresaDatos2,
                    novedadesEmpresaDatos: action.novedades,
                    rubros: action.rubros,
                    atlasBonificacionRenovacion: atlasBonificacionRenovacion2,
                    atlasCartera: atlasCartera2,
                    entidadInstaciasEquivalenciaCodigoIva: entidadInstaciasEquivalenciaCodigoIva2,
                    cuentaDatos: undefined,
                    entidadTipo: 0,
                    empresa: empresa2,
                    novedadesEmpresaDatos: novedadesEmpresaDatos2,
                    empresaDatosOriginal: empresaDatosOriginal2,
                    descripcionEmpresa: descripcionEmpresa2,
                    vistaCliente: action.vistaCliente.data,
                    cobraValorRenovacion: cobraValorRenovacion2,
                    novedadEmpresaValorAlRenovar: novedadEmpresaValorAlRenovar2,
                    atlasCartera: atlasCartera2,
                    categoriaIva: categoriaIva2,
                    porcentajeCodigoBonificacion: porcentajeCodigoBonificacion3,
                    cartera: cartera3,
                    getCodigoGeograficoVisa: getCodigoGeograficoVisa2,
                    mostrarSaldosResumenes: false,
                    mostrarIngresoAjustes: false,
                    funcionesDelUsuario: action.funcionesDelUsuario
                }
            }
            break;

        case CHANGE_DATES_CUENTA_PANEL:

            let cuentadatosParse = JSON.parse(JSON.stringify(action.cuenta));
            let sucursal3 = undefined;
            let modeloLiquidacion3 = undefined;
            let grupoAfinidad3 = undefined;
            let limiteCompra3 = undefined;
            let agrupamiento3 = undefined;
            let formaPago3 = undefined;
            let promotor3 = undefined;
            let lineaPrestamo3 = undefined;
            let categoriaCajero3 = undefined;
            let formaDebito3 = undefined;
            let cuentaBancariaNumero3 = undefined;

            if (action.cuenta.SucursalId != undefined) {
                let buscarSucursalObj3 = action.cuenta.accountData.GET_SUCURSAL.find(x => x.Id == action.cuenta.SucursalId);
                sucursal3 = {
                    'Id': buscarSucursalObj3.Id,
                    'Valor': buscarSucursalObj3.Descripcion
                }
            }

            if (action.cuenta.ModeloLiquidacionId != undefined) {
                let buscarModeloLiquidacionObj3 = action.cuenta.accountData.GET_MODELO_LIQUIDACION.find(x => x.Id == action.cuenta.ModeloLiquidacionId);
                modeloLiquidacion3 = {
                    'Id': buscarModeloLiquidacionObj3.Id,
                    'Valor': buscarModeloLiquidacionObj3.Descripcion
                }
            }

            if (action.cuenta.GrupoAfinidadId != undefined) {
                let buscarGrupoAfinidad3 = action.cuenta.accountData.GET_GRUPO_AFINIDAD.find(x => x.Id == action.cuenta.GrupoAfinidadId);
                grupoAfinidad3 = {
                    'Id': buscarGrupoAfinidad3.Id,
                    'Valor': buscarGrupoAfinidad3.Descripcion
                }
            }

            if (action.cuenta.LimiteCompraId != undefined) {
                let buscarLimiteCompra3 = action.cuenta.accountData.GET_LIMITE_COMPRA.find(x => x.Id == action.cuenta.LimiteCompraId);
                if (buscarLimiteCompra3) {
                    limiteCompra3 = {
                        'Id': buscarLimiteCompra3.Id,
                        'Valor': buscarLimiteCompra3.Valor
                    }
                }
                else {
                    limiteCompra3 = {
                        'Id': 0,
                        'Valor': 0
                    }
                }

            }

            if (action.cuenta.AgrupamientoVisaId != undefined) {
                let buscarAgrupamiento3 = action.cuenta.accountData.GET_AGRUPAMIENTO.find(x => x.Id == action.cuenta.AgrupamientoVisaId);
                agrupamiento3 = {
                    'Id': buscarAgrupamiento3.Id,
                    'Valor': buscarAgrupamiento3.Descripcion
                }
            }

            if (action.cuenta.FormaPagoId != undefined) {
                let buscarFormaPago3 = action.cuenta.accountData.GET_FORMA_PAGO.find(x => x.Id == action.cuenta.FormaPagoId);
                formaPago3 = {
                    'Id': buscarFormaPago3.Id,
                    'Valor': buscarFormaPago3.Descripcion
                }
            }

            if (action.cuenta.PromotorId != undefined) {
                let buscarPromotor3 = action.cuenta.accountData.GET_PROMOTOR.find(x => x.Id == action.cuenta.PromotorId);
                promotor3 = {
                    'Id': buscarPromotor3.Id,
                    'Valor': buscarPromotor3.Descripcion
                }
            }

            if (action.cuenta.LineaPrestamoVisaId != undefined) {
                let buscarLineaPrestamo3 = action.cuenta.accountData.GET_LINEA_PRESTAMO.find(x => x.Id == action.cuenta.LineaPrestamoVisaId);
                lineaPrestamo3 = {
                    'Id': buscarLineaPrestamo3.Id,
                    'Valor': buscarLineaPrestamo3.Descripcion
                }
            }

            if (action.cuenta.CategoriaCajeroVisaId != undefined) {
                let buscarCategoriaCajero3 = action.cuenta.accountData.GET_CATEGORIA_CAJERO.find(x => x.Id == action.cuenta.CategoriaCajeroVisaId);
                categoriaCajero3 = {
                    'Id': buscarCategoriaCajero3.Id,
                    'Valor': buscarCategoriaCajero3.Descripcion
                }
            }

            if (action.cuenta.FormaDebitoId != undefined) {
                let buscarFormaDebito3 = action.cuenta.accountData.GET_FORMA_DEBITO.find(x => x.Id == action.cuenta.FormaDebitoId);
                formaDebito3 = {
                    'Id': buscarFormaDebito3.Id,
                    'Valor': buscarFormaDebito3.Descripcion
                }
            }

            if (action.cuenta.CuentaBancariaNumero != undefined) {
                let cuentas3 = action.vistaCliente.data.GET_CUENTAS_BANCARIAS;

                //TODO: validar que hacer cuando llega un mensaje de error desde el wb
                if (!(cuentas3 instanceof Array)) {
                    cuentas3 = [];
                }

                let buscarCuentaBancariaNumero3 = cuentas3.find(x => x.numero == action.cuenta.CuentaBancariaNumero);

                if (buscarCuentaBancariaNumero3) {
                    cuentaBancariaNumero3 = {
                        'Id': buscarCuentaBancariaNumero3.numero,
                        'Valor': buscarCuentaBancariaNumero3.numero
                    }
                }
            }

            state.data.esNovedadEditada.map(function (row) {
                row.editado = false
            });

            result = {
                ...state,
                data: {
                    ...state.data,
                    vistaCliente: action.vistaCliente.data,
                    cuentaDatos: action.cuenta,
                    cuentaDatosOriginal: cuentadatosParse,
                    cuentaDenominacion: cuentadatosParse.CuentaDenominacion,
                    cuentaDescripcion: cuentadatosParse.Descripcion,
                    novedadesCuentaDatos: action.novedades,
                    empresaDatos: undefined,
                    sucursal: sucursal3,
                    modeloLiquidacion: modeloLiquidacion3,
                    grupoAfinidad: grupoAfinidad3,
                    limiteCompra: limiteCompra3,
                    agrupamiento: agrupamiento3,
                    formaPago: formaPago3,
                    promotor: promotor3,
                    lineaPrestamo: lineaPrestamo3,
                    categoriaCajero: categoriaCajero3,
                    formaDebito: formaDebito3,
                    cuentaBancariaNumero: cuentaBancariaNumero3,
                    entidadTipo: 1,
                    mostrarSaldosResumenes: false,
                    mostrarIngresoAjustes: false,
                    mostrarIngresoCobranzas: false,
                    funcionesDelUsuario: action.funcionesDelUsuario,
                    domiciliosService: action.cuenta.accountData.domiciliosService,
                    bajaId: action.bajaId,
                    features: action.features
                }
            }
            break;
        case CHANGE_ENTIDAD_TARJETA_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data,
                    entidadTipo: action.entidadTipo
                }
            }
            break;

        case CHANGE_DATES_TARJETA_PANEL:

            //DESARROLLAR
            result = {
                ...state,
                data: {
                    ...state.data,
                    cuentaDatos: action.cuenta,
                    tarjetasDatosOriginal: action.tarjetas,
                    motivosBloqueo: action.tarjetas.motivos,
                    motivosBaja: action.tarjetas.motivosBaja,
                    tarjetasDatos: action.tarjetas,
                    novedadesTarjetaDatos: action.novedades,
                    novedadesTarjetaDatosCanceladas: action.novedadesCanceladas,
                    tipoTarjetas: action.tipoTarjetas,
                    funcionesDelUsuario: action.funcionesDelUsuario,
                    mostrarSaldosResumenes: false,
                    mostrarIngresoAjustes: false,
                    mostrarIngresoCobranzas: false,
                    entidadTipo: 2
                }
            }
            break;

        case CHANGE_DATE_ERROR_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data,
                    dataPickerError: true
                }
            }
            break;

        case MOSTRAR_COMPONENTE_PANEL:

            break;

        case GUARDAR_CAMPO_PANEL: {

            const { valor, campo, params } = action;
            let valAnteriorCodGeo;

            switch (campo) {
                case "DomicilioCodigoGeografico": {
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            empresaDatos: {
                                ...state.data.empresaDatos,
                                [campo]: valor,
                                DomicilioCodigoGeograficoInput: "",
                                componenteSeleccionado: campo
                            }
                        },
                    }
                }
                case "DomicilioCodigoGeograficoInput": {
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            empresaDatos: {
                                ...state.data.empresaDatos,
                                [campo]: valor,
                                componenteSeleccionado: campo
                            }
                        },
                    }
                }
                case "DomicilioCorrespondenciaCodigoGeografico": {
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            cuentaDatos: {
                                ...state.data.cuentaDatos,
                                [campo]: valor,
                                componenteSeleccionado: campo,
                                DomicilioCorrespondenciaCodigoGeograficoInput: ""
                            }
                        },
                    }
                }
                case "DomicilioCorrespondenciaCodigoGeograficoInput": {
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            cuentaDatos: {
                                ...state.data.cuentaDatos,
                                componenteSeleccionado: campo,
                                [campo]: valor
                            }
                        },
                    }
                }
                case "DomicilioParticularCodigoGeografico": {
                    valAnteriorCodGeo = state.data.cuentaDatosOriginal.DomicilioParticularCodigoGeografico;

                    return {
                        ...state,
                        data:
                            {
                                ...state.data,
                                valorAnterior: valAnteriorCodGeo,
                                CodGeoPartSeleccionado: valor,
                                cuentaDatos: {
                                    ...state.data.cuentaDatos,
                                    [campo]: valor,
                                    componenteSeleccionado: campo,
                                    DomicilioParticularCodigoGeograficoInput: "",


                                }
                            },
                    }
                }
                case "DomicilioParticularCodigoGeograficoInput": {
                    valAnteriorCodGeo = state.data.cuentaDatosOriginal.DomicilioParticularCodigoGeografico;
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            valorAnterior: valAnteriorCodGeo,
                            cuentaDatos: {
                                ...state.data.cuentaDatos,
                                componenteSeleccionado: campo,
                                [campo]: valor

                            }
                        },
                    }
                }
            }
        }
            break;

        case GET_DOMICILIOS_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data,
                    domiciliosService: action.domiciliosService
                }
            }
            break;

        case GET_CUENTAS_SUCURSALES_PANEL:

            let cuentaBancariaSucursalId3;
            if (state.data.cuentaDatos.accountData.CuentaBancariaSucursalId != undefined) {
                let buscarCuentaBancariaSucursalId = action.sucursalesCuentas.find(x => x.Id == state.data.cuentaDatos.accountData.CuentaBancariaSucursalId);
                cuentaBancariaSucursalId3 = {
                    'Id': buscarCuentaBancariaSucursalId.Id,
                    'Valor': buscarCuentaBancariaSucursalId.Descripcion
                }
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    sucursalesCuentas: action.sucursalesCuentas,
                    cuentaBancariaSucursalId: cuentaBancariaSucursalId3,
                    cuentaDatos: {
                        ...state.data.cuentaDatos,
                        cuentaDatos: {
                            ...state.data.cuentaDatos.accountData,
                            GET_CUENTAS_BANCARIAS: action.GET_CUENTAS_BANCARIAS
                        }

                    }
                }
            }
            break;

        case CHANGE_CHECK_PANEL:

            let valorAnterior4;
            let existeNovedad4;
            let index4;
            let seEstaEditandoValorRenovacion4;
            switch (action.entidadId) {
                case 0:
                    switch (action.componente) {
                        case 'ESCON_EMPR': //Es Confidecial
                            valorAnterior4 = state.data.empresaDatosOriginal.EsConfidencial;
                            state.data.empresaDatos.EsConfidencial = action.value;
                            break;
                        case 'NUECL_EMPR': //Debe cambiar la clave del home banking de Visa en el próximo acceso
                            valorAnterior4 = state.data.empresaDatosOriginal.GeneraNuevaClave;
                            state.data.empresaDatos.GeneraNuevaClave = action.value;
                            break;
                        case 'PERAD_EMPR': //Permite adelantos
                            valorAnterior4 = state.data.empresaDatosOriginal.PermiteAdelantos;
                            state.data.empresaDatos.PermiteAdelantos = action.value;
                            break;
                        case 'LIMTR_EMPR': //Tiene límite por transacción
                            valorAnterior4 = state.data.empresaDatosOriginal.TieneLimiteTransaccion;
                            state.data.empresaDatos.TieneLimiteTransaccion = action.value;
                            break;
                        case 'CONEX_EMPR': //Permite consumos en el exterior
                            valorAnterior4 = state.data.empresaDatosOriginal.PermiteConsumosExterior;
                            state.data.empresaDatos.PermiteConsumosExterior = action.value;
                            break;
                        case 'REPCU_EMPR': //Genera reporte de cuenta central
                            valorAnterior4 = state.data.empresaDatosOriginal.GeneraReporteCuentaCentral;
                            state.data.empresaDatos.GeneraReporteCuentaCentral = action.value;
                            break;
                        case 'MODLI_EMPR': //Toma los gastos de emisión del resumen del modelo de liquidación
                            valorAnterior4 = state.data.empresaDatosOriginal.TomaGastosModeloLiquidacion;
                            state.data.empresaDatos.TomaGastosModeloLiquidacion = action.value;
                            break;
                        case 'ACTRE_EMPR': //Actualizar el valor al renovar
                            valorAnterior4 = state.data.empresaDatosOriginal.CobraValorRenovacion;
                            state.data.empresaDatos.CobraValorRenovacion = action.value;
                            seEstaEditandoValorRenovacion4 = true;
                            break;
                        default:
                    }
                    existeNovedad4 = state.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                case 1:
                    switch (action.componente) {

                        default:
                    }
                    existeNovedad4 = state.data.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                case 2:
                    switch (action.componente) {
                        case 'ESTEM_TARJ':

                            index = state.data.tarjetasDatosOriginal.findIndex(x => x.TarjetaCreditoId == action.id);

                            if (index != -1) {
                                valorAnterior4 = state.data.tarjetasDatosOriginal[index].EsTarjetaTemporal == null ? "" : state.data.tarjetasDatosOriginal[index].EsTarjetaTemporal;
                                state.data.tarjetasDatos[index].EsTarjetaTemporal = action.value;
                            }

                            break;
                        default:
                    }
                    existeNovedad4 = state.data.novedadesTarjetaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
            }

            if (existeNovedad4 != undefined) {
                index4 = state.data.esNovedadEditada.findIndex(x => x.campoCodigo == action.componente);
                state.data.esNovedadEditada[index4].editado = true;
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    componenteSeleccionado: action.componente,
                    valorAnterior: valorAnterior4,
                    seEstaEditandoValorRenovacion: seEstaEditandoValorRenovacion4
                }
            }
            break;

        case CHANGE_DATE_PANEL:

            let valorAnterior8;
            let existeNovedad8;
            let index8;
            switch (action.entidadId) {
                case 0:
                    switch (action.componente) {
                        case 'VIGPL_EMPR': //Aplica nuevo precio a partir de
                            valorAnterior8 = state.data.empresaDatosOriginal.FechaTopeRenovacion;
                            state.data.empresaDatos.FechaTopeRenovacion = action.value;
                            break;
                        case 'FETOP_EMPR': //Fecha Tope Agro
                            valorAnterior8 = state.data.empresaDatosOriginal.FechaTopeAgro;
                            state.data.empresaDatos.FechaTopeAgro = action.value;
                            break;
                        default:
                    }
                    existeNovedad8 = state.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
                case 1:
                    switch (action.componente) {

                        default:
                    }
                    existeNovedad8 = state.data.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == state.data.componenteSeleccionado);
                    break;
            }

            if (existeNovedad8 != undefined) {
                index8 = state.data.esNovedadEditada.findIndex(x => x.campoCodigo == action.componente);
                state.data.esNovedadEditada[index8].editado = true;
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    componenteSeleccionado: action.componente,
                    valorAnterior: valorAnterior8,
                    valorDataPickerSeleccionado: action.value,
                    dataPickerError: false
                }
            }
            break;

        case SAVE_NOVEDAD_PANEL:

            let index6 = state.data.esNovedadEditada.findIndex(x => x.campoCodigo == state.data.componenteSeleccionado);
            /*cuando se guarda una novedad de tarjetas (baja o bloqueo), no tiene componente seleccionado no necesita modificar ningun estado*/
            if (index6 > 0) {
                state.data.esNovedadEditada[index6].editado = true;
            }
            state.data.loading = false;

            switch (action.entidadId) {
                case 0:
                    let buscarNovedadEmpresa2 = action.data.find(x => x.NovedadCampoCodigo == "ACTRE_EMPR");
                    let novedadEmpresaValorAlRenovar2 = buscarNovedadEmpresa2 != undefined ? buscarNovedadEmpresa2 : null
                    let cobraValorRenovacion2 = (novedadEmpresaValorAlRenovar2 != undefined ? (novedadEmpresaValorAlRenovar2.ValorNovedad == "0" ? false : true) : (null))

                    return {
                        ...state,
                        data: {
                            ...state.data,
                            componenteSeleccionado: undefined,
                            valorAnterior: undefined,
                            seEstaEditando: false,
                            empresaDatosOriginal: JSON.parse(JSON.stringify(state.data.empresaDatos)),
                            novedadesEmpresaDatos: action.data,
                            novedadEmpresaValorAlRenovar: novedadEmpresaValorAlRenovar2,
                            cobraValorRenovacion: cobraValorRenovacion2,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                            mostrarCodigoGeografico: false
                        }
                    }
                /*Cuenta*/
                case 1: {
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            componenteSeleccionado: undefined,
                            valorAnterior: undefined,
                            seEstaEditando: false,
                            cuentaDatosOriginal: JSON.parse(JSON.stringify(state.data.cuentaDatos)),
                            novedadesCuentaDatos: action.dataCuenta,
                            mostrarCodigoGeografico: false,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                        }
                    }
                    break;
                }
                case 2:
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            componenteSeleccionado: undefined,
                            valorAnterior: undefined,
                            seEstaEditando: false,
                            tarjetasDatosOriginal: JSON.parse(JSON.stringify(state.data.tarjetasDatos)),
                            novedadesTarjetaDatos: action.dataTarjeta,
                            novedadesTarjetaDatosCanceladas: action.novedadesTarjetaCanceladas,
                            mostrarCodigoGeografico: false,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                        }
                    }
                    break;
                default:
            }
            break;

        case CANCEL_NOVEDAD_PANEL:

            let index7 = state.data.esNovedadEditada.findIndex(x => x.campoCodigo == state.data.componenteSeleccionado);
            if (index7 > -1)
                state.data.esNovedadEditada[index7].editado = false;
            switch (action.entidadId) {
                case 0:
                    /*Se tuvo que hacer este "hack" para que las novedades de domicilio finalmente puedan funcionar*/
                    let empresaDatosCopia = JSON.parse(JSON.stringify(state.data.empresaDatosOriginal));

                    const novedadDMCGE = state.data.novedadesEmpresaDatos.find((ned) => ned.NovedadCampoCodigo == "DMCGE_EMPR");
                    const codGeograficoVisa = state.data.getCodigoGeograficoVisa.find((cgv) => {
                        if (novedadDMCGE) {
                            return (cgv.CodigoGeografico == novedadDMCGE.ValorNovedad);
                        } else {
                            return (cgv.CodigoGeografico == empresaDatosCopia.DomicilioCodigoGeografico);
                        }
                    });

                    if (novedadDMCGE) {
                        if (codGeograficoVisa) {
                            empresaDatosCopia.DomicilioCodigoGeografico = novedadDMCGE.ValorNovedad;
                            empresaDatosCopia.DomicilioCodigoGeograficoInput = "";
                        } else {
                            empresaDatosCopia.DomicilioCodigoGeografico = "0";
                            empresaDatosCopia.DomicilioCodigoGeograficoInput = novedadDMCGE.ValorNovedad;
                        }
                    } else {
                        if (codGeograficoVisa == undefined) {
                            empresaDatosCopia.DomicilioCodigoGeograficoInput = empresaDatosCopia.DomicilioCodigoGeografico;
                            empresaDatosCopia.DomicilioCodigoGeografico = "0";
                        }
                    }
                    /*fin*/

                    return {
                        ...state,
                        data: {
                            ...state.data,
                            loading: false,
                            seEstaEditando: false,
                            empresaDatos: empresaDatosCopia,
                            valorAnterior: undefined,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                            mostrarCodigoGeografico: false,
                            cartera: state.data.carteraOriginal,
                            porcentajeCodigoBonificacion: state.data.porcentajeCodigoBonificacionOriginal
                        }
                    }
                case 1:
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            loading: false,
                            seEstaEditando: false,
                            cuentaDatos: JSON.parse(JSON.stringify(state.data.cuentaDatosOriginal)),
                            valorAnterior: undefined,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                            mostrarCodigoGeografico: false,
                            sucursal: state.data.sucursalOriginal,
                            agrupamiento: state.data.agrupamientoOriginal,
                            categoriaCajero: state.data.categoriaCajeroOriginal,
                            formaDebito: state.data.formaDebitoOriginal,
                            cuentaBancariaNumero: state.data.cuentaBancariaNumeroOriginal,
                            modeloLiquidacion: state.data.modeloLiquidacionOriginal,
                            lineaPrestamo: state.data.lineaPrestamoOriginal,
                            limiteCompra: state.data.limiteCompraOriginal,
                            grupoAfinidad: state.data.grupoAfinidadOriginal,
                            promotor: state.data.promotorOriginal,
                            formaPago: state.data.formaPagoOriginal
                        }
                    }
                case 2:
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            loading: false,
                            seEstaEditando: false,
                            tarjetasDatos: JSON.parse(JSON.stringify(state.data.tarjetasDatosOriginal)),
                            valorAnterior: undefined,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                            mostrarCodigoGeografico: false
                        }
                    }
                    break;
                default:
                    return {
                        ...state,
                        data: {
                            ...state.data,
                            loading: false,
                            seEstaEditando: false,
                            valorAnterior: undefined,
                            valorSelectIdSeleccionado: undefined,
                            valorDataPickerSeleccionado: undefined,
                            seEstaEditandoValorRenovacion: undefined,
                            dataPickerError: false,
                            mostrarCodigoGeografico: false
                        }
                    }
            }
            break;

        case ESTADO_EDICION_PANEL:

            result = {
                ...state,
                data: {
                    ...state.data,
                    seEstaEditando: action.estado,
                    componenteSeleccionado: action.componente
                }
            }
            break;

        case CHANGE_TEXT:

            result = {
                ...state,
                data: {
                    ...state.data,
                    mensajeActivo: action.estado
                }
            }
            break;

        case CHANGE_EDIT_VIEW:

            result = {
                ...state,
                data: {
                    ...state.data,
                    seVisualizaEditado: action.estado
                }
            }
            break;

        case BLOQUEAR_TARJETA: {

            result = {
                ...state,
                data: {
                    ...state.data,
                    esTarjetaBloqueada: true
                }
            }
            break;
        }

        case GET_NOVEDADES_BY_ID_AND_CODIGO: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    novedadesHistoria: action.novedadesHistoria
                }
            }
            break;
        }

        case ESTA_GUARDANDO_PANEL: {

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: true
                }
            }
            break;
        }

        case MOSTRAR_MODAL: {
            if (action.mostrar == false) {
                state.data.novedadesHistoria = undefined;
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    tituloCampo: action.tituloCampo,
                    estaVisibleModalNovedad: action.mostrar,
                    componenteSeleccionado: action.novedadCampoCodigo
                }
            }
            break;
        }

        case MOSTRAR_SALDOS_RESUMENES: {

            result = {
                ...state,
                data: {
                    ...state.data,
                    mostrarSaldosResumenes: true,
                    ...state.data.vistaCliente,
                    idEntidad: action.id
                }
            }

            result.data.entidadTipo = 1;
            break;
        }

        case MOSTRAR_INGRESO_AJUSTES: {

            result = {
                ...state,
                data: {
                    ...state.data,
                    mostrarIngresoAjustes: true,
                    ...state.data.vistaCliente,
                    idEntidad: action.id
                }
            }

            result.data.entidadTipo = 3;
            break;
        }

        case MOSTRAR_INGRESO_COBRANZAS: {

            result = {
                ...state,
                data: {
                    ...state.data,
                    mostrarIngresoCobranzas: true,
                    ...state.data.vistaCliente,
                    idEntidad: action.id
                }
            }

            result.data.entidadTipo = 4;
            break;
        }

        case VALOR_TEXT_AREA: {

            result = {
                ...state,
                data: {
                    ...state.data,
                    valorTxtArea: action.txtArea,
                }
            }
            break;
        }

        case ACTUALIZAR_ESTADO_NOVEDAD: {
            let campoNovedad = "";
            let campoNovedadCancelada = "deleteMe";
            switch (action.novedadTipoId) {
                /*tarjeta*/
                case 2: {
                    campoNovedad = "novedadesTarjetaDatos";
                    campoNovedadCancelada = "novedadesTarjetaDatosCanceladas"
                    break;
                }
                /*cuenta*/
                case 1: {
                    campoNovedad = "novedadesCuentaDatos";
                    break;
                }
                /*empresa*/
                case 3: {
                    campoNovedad = "novedadesEmpresaDatos";
                    break;
                }

            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    [campoNovedad]: action.novedades,
                    [campoNovedadCancelada]: action.novedadesCanceladas
                }
            }

            if (action.novedadTipoId != 2) {
                delete result.data.deleteMe;
            }

            break;
        }

        case MOSTRAR_SPINNER: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: true
                }
            }
            break;
        }

        case OCULTAR_SPINNER_PANEL_SELECCION: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false
                }
            }
            break;
        }

        case GET_DIAS_VIGENCIA_PANEL: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    vigenciaTarjeta: action.vigencias
                }
            }
            break;
        }

        default:

            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(panelSeleccion.name, result);
    return result;
}

/**
 * 
 * @param {any} state
 * @param {any} valueBuscador
 * @param {any} select
 */
function setRubroValue(state, valueBuscador, select) {
    LogHelper.In(setRubroValue.name, state, valueBuscador, select);

    let value = "";
    let i;

    if (valueBuscador != "") {
        if (valueBuscador.length > 3) {
            let rubro = state.data.empresaDatos.rubros.find(x => x.Descripcion == valueBuscador);
            if (rubro != undefined) {
                let rubrosEmpresa = state.data.empresaDatos.rubros.filter(x => x.selected);
                if (select) {
                    if (rubrosEmpresa.length < 9) {
                        rubro.selected = select;
                        value = "";
                    }
                }
                else {
                    rubro.selected = select;
                    value = "";
                }

            } else {
                value = valueBuscador;
            }
        } else {
            value = valueBuscador;
        }
    } else {
        value = valueBuscador;
    }

    state.data.valueBuscador = value;
}

/**
 * 
 * @param {any} state
 */
function limpiarRubros(state) {
    LogHelper.In(limpiarRubros.name, state);

    state.data.empresaDatos.rubros.forEach(function (rubro) {
        rubro.selected = false;
    });
}

/**
 * 
 * @param {any} state
 * @param {any} typeInput
 * @param {any} isCheck
 */
function filtroRubro(state, typeInput, isCheck) {
    LogHelper.In(filtroRubro.name, state, typeInput, isCheck);

    switch (typeInput) {
        case "todos":
            state.data.empresaDatos.RubroIncluidoExcluido = null;
            break;
        case "todosExcepto":
            state.data.empresaDatos.RubroIncluidoExcluido = state.data.empresaDatos.RubroIncluidoExcluido != "E" ? "E" : null;
            break;
        case "solamente":
            state.data.empresaDatos.RubroIncluidoExcluido = "I";
            break;
        default:
            break;
    }
}

export default panelSeleccion;